import { Card, Col, Row, Typography, Input, Button, Spin } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { Link, useParams } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { BACKEND_URL } from '../Backend'; 
import UploadArchivo from '../pages/UploadArchivo'
import BotonDescargarPDF from '../pages/BotonDescargarPDF'
import SelectCuatrimestre from '../pages/SelectCuatrimestre';
import axios from 'axios';

const cookies = new Cookies();
const { Meta } = Card;
const { Title } = Typography;
const { Search } = Input;

function AlumnosPorCarrera() {
  
  const navigation = useNavigate();
  const { pk_carrera } = useParams();
  const [alumnosporcarreras, setAlumnosPorCarreras] = useState([]);
  const [nombreCarrera, setNombreCarrera] = useState('');
  const [cuatrimestreSeleccionado, setCuatrimestreSeleccionado] = useState('');
  const [filtro, setFiltro] = useState('');
  const [cargando, setCargando] = useState(false);
  const [refrescar, setRefrescar] = useState(false);

  // Función para manejar el cambio de cuatrimestre (MOVIDA FUERA DEL useEffect)
  const handleCuatrimestreChange = (cuatrimestre) => {
    setCuatrimestreSeleccionado(cuatrimestre);
    console.log('Cuatrimestre seleccionado:', cuatrimestre);
  };

  useEffect(() => {
    if (parseInt(cookies.get('nivel')) !== 4) {
      navigation('/');
      return;
    }

    setCargando(true);

    axios.get(`${BACKEND_URL}/alumnosPorCarrera/${pk_carrera}`)
    .then(async (response) => {
      const alumnos = response.data;

      const alumnosConArchivos = await Promise.all(alumnos.map(async alumno => {
        try {
          // Obtener la lista de archivos del alumno
          const res = await axios.get(`${BACKEND_URL}/listarArchivos/${encodeURIComponent(alumno.nombre_carrera)}/${encodeURIComponent(alumno.cuatrimestre_grupo)}/${encodeURIComponent(alumno.nombre_alumno)}`);
          
          const archivos = res.data.archivos || [];
          const tieneArchivos = archivos.length > 0;
          const primerArchivo = tieneArchivos ? archivos[0] : null;

          return {
            ...alumno,
            archivoExiste: tieneArchivos,
            nombreArchivo: primerArchivo,
            archivos: archivos 
          };
        } catch (error) {
          console.error('Error al obtener archivos del alumno:', error);
          return {
            ...alumno,
            archivoExiste: false,
            nombreArchivo: null,
            archivos: []
          };
        }
      }));

      setAlumnosPorCarreras(alumnosConArchivos);

      if (response.data.length > 0) {
        setNombreCarrera(response.data[0].nombre_carrera);
      } else {
        setNombreCarrera('Carrera no encontrada');
      }
    })
    .catch((error) => {
      console.error('Error al obtener alumnos de la carrera:', error);
      setNombreCarrera('Error al cargar la carrera');
    }).finally(() => {
      setCargando(false);
    });

  }, [pk_carrera, navigation, refrescar]);

  // Filtrar alumnos por nombre Y cuatrimestre
  const alumnosFiltrados = alumnosporcarreras.filter(alumno => {
    // Filtro por texto (nombre, cuatrimestre, matrícula)
    const cumpleFiltroTexto = 
      alumno.nombre_alumno.toLowerCase().includes(filtro.toLowerCase()) ||
      alumno.cuatrimestre_grupo.toLowerCase().includes(filtro.toLowerCase()) ||
      (alumno.matricula && alumno.matricula.toString().toLowerCase().includes(filtro.toLowerCase()));
    
    // Filtro por cuatrimestre seleccionado
    const cumpleFiltroCuatrimestre = 
      !cuatrimestreSeleccionado || 
      alumno.cuatrimestre_grupo.includes(cuatrimestreSeleccionado);
    
    return cumpleFiltroTexto && cumpleFiltroCuatrimestre;
  });

  return(
    <Spin spinning={cargando} size="large" tip="Cargando...">
      <div style={{ minHeight: '300px' }}>
        <div>
          <Title level={2} style={{ marginBottom: 20 }}>{nombreCarrera}</Title>
          
          {/* Select de cuatrimestre */}
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', marginBottom: 8, fontWeight: 'bold' }}>
              Filtrar por cuatrimestre:
            </label>
            <SelectCuatrimestre
              value={cuatrimestreSeleccionado}
              onCuatrimestreChange={handleCuatrimestreChange}
              placeholder="Todos los cuatrimestres"
              style={{ width: 300 }}
            />
          </div>

          {/* Buscador */}
          <Search 
            placeholder="Buscar alumno por nombre, matrícula o grupo"
            allowClear
            enterButton="Buscar"
            size="large"
            onSearch={value => setFiltro(value)}
            onChange={e => setFiltro(e.target.value)}
            style={{ marginBottom: 20, maxWidth: 400 }}
          />

          {/* Mostrar contador de resultados */}
          <div style={{ marginBottom: 16, color: '#666' }}>
            {alumnosFiltrados.length} alumno(s) encontrado(s)
            {cuatrimestreSeleccionado && ` en ${cuatrimestreSeleccionado}° cuatrimestre`}
          </div>

          <Row gutter={16}>
            {alumnosFiltrados.map((alumno, index) => (
              <Col span={8} key={index}>
                <Card title={alumno.nombre_alumno} style={{ marginBottom: 20 }}>
                  <p><strong>Matrícula:</strong> {alumno.matricula}</p>
                  <p><strong>Cuatrimestre - Grupo:</strong> {alumno.cuatrimestre_grupo}</p>

                  <UploadArchivo alumno={alumno} onUploadSuccess={() => setRefrescar(prev => !prev)} />

                  {alumno.archivoExiste && alumno.nombreArchivo && (
                    <div style={{ marginTop: '10px' }}>
                      <BotonDescargarPDF alumno={alumno} nombreArchivo={alumno.nombreArchivo}/>
                      <Button
                        type="link"
                        href={`${BACKEND_URL}/archivos/${encodeURIComponent(alumno.nombre_carrera)}/${encodeURIComponent(alumno.cuatrimestre_grupo)}/${encodeURIComponent(alumno.nombre_alumno)}/${encodeURIComponent(alumno.nombreArchivo)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Ver PDF
                      </Button>
                    </div>
                  )}
                </Card>
              </Col>
            ))}
          </Row>

          {/* Mensaje cuando no hay resultados */}
          {alumnosFiltrados.length === 0 && !cargando && (
            <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
              No se encontraron alumnos con los filtros aplicados
            </div>
          )}
        </div>
      </div>
    </Spin>
  );
};

export default AlumnosPorCarrera;